// ts-rest contract for Comply > Fair Value. Read-only — returns the
// `all_clients` id->name lookup the page uses to resolve the
// ARBITER ComposerTriggerButton's clientId.

import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { clientStubSchema } from '../schemas/clients';

const c = initContract();

export const fairValueResponseSchema = z.object({
    clientNames: z.array(clientStubSchema),
});
export type FairValueResponse = z.infer<typeof fairValueResponseSchema>;

import { errorBody } from '../schemas/common';

export const complyFairValueContract = c.router(
    {
        get: {
            method: 'GET',
            path: '/comply/fair-value',
            responses: { 200: fairValueResponseSchema, 403: errorBody },
            summary: 'Comply > Fair Value reference data (client id/name lookup)',
        },
    },
    { pathPrefix: '/api', strictStatusCodes: false },
);
